const getters = {
  episode: state => state.episode,
  episodes: state => state.episodes,
  episodeCount: state => state.episodeCount,
  episodeCreationKeys: state => state.episodeCreationKeys,
  episodeList: state => state.episodeList,
  lastEpisode: state => state.lastEpisode,
  topEpisode: state => state.topEpisode
}

export default getters
